import DebugDisplay from './DebugDisplay'
import QuickBooksReportDisplay from './QuickBooksReportDisplay'

const DISPLAY_STRATEGY_MAP = {
  debug: DebugDisplay,
  'quickbooks-report': QuickBooksReportDisplay
}

export function getDisplayStrategy (name) {
  return DISPLAY_STRATEGY_MAP[name] || DebugDisplay
}

export function detectStrategy (artifact) {
  if (artifact?.code?.startsWith('reports/')) return 'quickbooks-report'
  return 'debug'
}

export default DISPLAY_STRATEGY_MAP
